import React, { useState } from 'react';

// Import images directly
import cohort1 from '../../assets/cfye-images/cohort1.png';
import cohort2 from '../../assets/cfye-images/cohort2.png';
import cohort3 from '../../assets/cfye-images/cohort3.png';
import cohort4 from '../../assets/cfye-images/cohort4.png';
import cohort5 from '../../assets/cfye-images/cohort5.png';
import cohort6 from '../../assets/cfye-images/cohort6.png';
import cohort7 from '../../assets/cfye-images/cohort7.png';

export default function Impact() {
  const [activeRow1, setActiveRow1] = useState(1);
  const [activeRow2, setActiveRow2] = useState(null);

  const cohortsRow1 = [
    { id: 1, src: cohort1, label: 'Cohort 1' },
    { id: 2, src: cohort2, label: 'Cohort 2' },
    { id: 3, src: cohort3, label: 'Cohort 3' },
  ];

  const cohortsRow2 = [
    { id: 4, src: cohort4, label: 'Cohort 4' },
    { id: 5, src: cohort5, label: 'Cohort 5' },
    { id: 6, src: cohort6, label: 'Cohort 6' },
  ];

  return (
    <section className="flex flex-col items-center justify-center w-full py-14 lg:py-24 px-6 sm:px-10 lg:px-20">
      {/* Heading Section */}
      <div className="text-center mb-10">
        <h1 className="lg:max-w-5xl mx-auto text-3xl sm:text-4xl lg:text-5xl text-text-color tracking-normal font-normal pt-4 uppercase">
          Our Impact from Each{' '}
          <span className="font-serif italic text-primary font-semibold">
            Cohort
          </span>
        </h1>
        <p className="lg:max-w-3xl mx-auto text-center text-text-color pt-4 text-sm sm:text-base">
          Celebrating the women who are transforming their ideas into thriving
          businesses through the Dream to Business Incubator Program.
        </p>
      </div>

      {/* === Row 1 (Cohorts 1–3) === */}
      <div className="flex flex-col sm:flex-row justify-center items-center gap-5 lg:gap-6 w-full mb-10">
        {cohortsRow1.map((cohort) => (
          <div
            key={cohort.id}
            onMouseEnter={() => setActiveRow1(cohort.id)}
            onMouseLeave={() => setActiveRow1(1)}
            className={`relative overflow-hidden rounded-2xl transition-all duration-500 ease-in-out cursor-pointer shadow-lg
              ${
                activeRow1 === cohort.id
                  ? 'flex-[1.4] lg:flex-[2]'
                  : 'flex-[0.8] lg:flex-[1]'
              } w-full h-56 sm:h-72 md:h-80 lg:h-[28rem]`}
          >
            <img
              src={cohort.src}
              alt={cohort.label}
              className="w-full h-full object-cover transition-transform duration-500 ease-in-out hover:scale-105"
            />
            <div className="absolute top-4 right-4 bg-white/90 text-gray-800 text-sm font-medium px-4 py-1 rounded-full shadow-md">
              {cohort.label}
            </div>
          </div>
        ))}
      </div>

      {/* === Row 2 (Cohorts 4–6) === */}
      <div className="flex flex-col sm:flex-row justify-center items-center gap-5 lg:gap-6 w-full mb-10">
        {cohortsRow2.map((cohort) => (
          <div
            key={cohort.id}
            onMouseEnter={() => setActiveRow2(cohort.id)}
            onMouseLeave={() => setActiveRow2(null)}
            className={`relative overflow-hidden rounded-2xl transition-all duration-500 ease-in-out cursor-pointer shadow-lg
              ${
                activeRow2 === null
                  ? 'flex-[1] lg:flex-[1]'
                  : activeRow2 === cohort.id
                  ? 'flex-[1.4] lg:flex-[1.8]'
                  : 'flex-[0.8] lg:flex-[1]'
              } w-full h-56 sm:h-72 md:h-80 lg:h-[28rem]`}
          >
            <img
              src={cohort.src}
              alt={cohort.label}
              className="w-full h-full object-cover transition-transform duration-500 ease-in-out hover:scale-105"
            />
            <div className="absolute top-4 right-4 bg-white/90 text-gray-800 text-sm font-medium px-4 py-1 rounded-full shadow-md">
              {cohort.label}
            </div>
          </div>
        ))}
      </div>

      {/* === Cohort 7 (Single Static Image) === */}
      <div className="relative w-full rounded-2xl overflow-hidden shadow-lg">
        <img
          src={cohort7}
          alt="Cohort 7"
          className="w-full h-64 sm:h-80 md:h-[28rem] object-cover"
        />
        <div className="absolute top-4 right-4 bg-white/90 text-gray-800 text-sm font-medium px-4 py-1 rounded-full shadow-md">
          Cohort 7
        </div>
      </div>
    </section>
  );
}
